import {Injectable}                  from '@angular/core';
import {BehaviorSubject}             from 'rxjs';
import {v4 as uuidv4}                from 'uuid';
import {MenuDragPanelAsstComponent}  from '../comps/menu-drag/menu-drag-panels/menu-drag-panel-asst/menu-drag-panel-asst.component';
import {MenuDragPanelBase}           from '../comps/menu-drag/menu-drag-panels/menu-drag-panel-base';
import {MenuDragPanelLogComponent}   from '../comps/menu-drag/menu-drag-panels/menu-drag-panel-log/menu-drag-panel-log.component';
import {MenuBase, MenuBasePanelIntf} from './menu-base';


export type MenuDragType =
	| 'log'
	| 'asst'

@Injectable({
				providedIn: 'root'
			})
export class MenuDragService implements MenuBase<MenuDragType, MenuDragPanelBase> {


	menuOpen = new BehaviorSubject<boolean>(false);
	menuType = new BehaviorSubject<MenuDragType | undefined>(undefined);
	menuPanels: MenuBasePanelIntf<MenuDragType, MenuDragPanelBase>[] = [
		{
			name: 'Log',
			comp: MenuDragPanelLogComponent,
			icon: 'database',
			uuid: uuidv4(),
			type: 'log'
		},
		{
			name: 'Assistant',
			comp: MenuDragPanelAsstComponent,
			icon: 'robot',
			uuid: uuidv4(),
			type: 'asst'
		}
	]


}
